(function () {
  const instances = new Map();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseDelay(section) {
    const delay = parseInt(section.getAttribute('data-delay'), 10);
    return Number.isFinite(delay) && delay > 0 ? delay : 5000;
  }

  function autoplayEnabled(section) {
    if (prefersReducedMotion()) return false;
    return section.getAttribute('data-autoplay') === 'true';
  }

  function autoplayConfig(section) {
    if (!autoplayEnabled(section)) return false;
    return {
      delay: parseDelay(section),
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };
  }

  function destroySwiper(swiper) {
    if (!swiper) return;
    try {
      swiper.destroy(true, true);
    } catch (e) {
      /* ignore */
    }
  }

  function createSwiper(section, container) {
    if (!window.XBLOOM3 || !window.XBLOOM3.Swiper) return null;
    if (!container) return null;
    if (container.swiper) destroySwiper(container.swiper);

    const slideCount = container.querySelectorAll('.swiper-slide').length;
    const canLoop = slideCount > 1;
    const prevEl = section.querySelector('[data-stories-prev]');
    const nextEl = section.querySelector('[data-stories-next]');
    const navigation =
      prevEl && nextEl
        ? {
            prevEl: prevEl,
            nextEl: nextEl,
          }
        : undefined;

    return new window.XBLOOM3.Swiper(container, {
      slidesPerView: 1,
      autoHeight: true,
      speed: prefersReducedMotion() ? 0 : 500,
      loop: canLoop,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      watchOverflow: true,
      grabCursor: canLoop,
      allowTouchMove: true,
      autoplay: canLoop ? autoplayConfig(section) : false,
      navigation: navigation,
    });
  }

  function bindInview(section, instance) {
    if (prefersReducedMotion()) {
      section.classList.add('is-inview');
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      section.classList.add('is-inview');
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-inview');
          observer.unobserve(section);
        });
      },
      { threshold: 0.25 }
    );

    instance.inviewObserver = observer;
    observer.observe(section);
  }

  function destroy(section) {
    const instance = instances.get(section);
    if (!instance) return;
    if (instance.inviewObserver) {
      instance.inviewObserver.disconnect();
    }
    destroySwiper(instance.swiper);
    instances.delete(section);
  }

  function init(section) {
    if (!section || instances.has(section)) return;

    const container = section.querySelector('[data-stories-swiper]');
    if (!container) return;

    const instance = {
      container: container,
      swiper: createSwiper(section, container),
      inviewObserver: null,
    };

    instances.set(section, instance);
    bindInview(section, instance);
  }

  function initAll(context) {
    const root = context || document;

    if (root.classList && root.classList.contains('stories-swiper')) {
      init(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.stories-swiper') : [];
    sections.forEach(init);
  }

  function waitForSwiper(attempt) {
    if (window.XBLOOM3 && window.XBLOOM3.Swiper) {
      initAll(document);
      return;
    }

    if (attempt > 20) return;
    setTimeout(function () {
      waitForSwiper(attempt + 1);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(0);
    });
  } else {
    waitForSwiper(0);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target;

    if (root.classList && root.classList.contains('stories-swiper')) {
      destroy(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.stories-swiper') : [];
    sections.forEach(destroy);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const sectionEl = event.target.closest ? event.target.closest('.stories-swiper') : null;
    if (!sectionEl) return;

    const instance = instances.get(sectionEl);
    if (!instance || !instance.swiper) return;

    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;

    const index = parseInt(slide.getAttribute('data-slide-index'), 10);
    if (!Number.isFinite(index)) return;

    if (typeof instance.swiper.slideToLoop === 'function' && instance.swiper.params.loop) {
      instance.swiper.slideToLoop(index);
    } else if (typeof instance.swiper.slideTo === 'function') {
      instance.swiper.slideTo(index);
    }
  });
})();
